export const REGISTER_EMAIL = "REGISTER_EMAIL"
export const SEND_CODE = "SEND_CODE"
export const REGISTER_USER = "REGISTER_USER"
export const ECONOMIC_ACTIVITIES = "ECONOMIC_ACTIVITIES"
export const GET_CATEGORIES = "GET_CATEGORIES"
export const IS_LOADING_ECONOMIC_ACTIVITIES = "IS_LOADING_ECONOMIC_ACTIVITIES"

export const LOGIN_EMAIL = "LOGIN_EMAIL"
export const IS_LOADING_LOGIN_PASSWORD = "IS_LOADING_LOGIN_PASSWORD"
export const NOT_LOADING_LOGIN_PASSWORD = "NOT_LOADING_LOGIN_PASSWORD"
export const LOGIN_EMAIL_PASSWORD = "LOGIN_EMAIL_PASSWORD"
export const PERSONAL_CODE_REFERAL = "PERSONAL_CODE_REFERAL"
export const PERSONAL_CODE_REFERAL_ERROR = "PERSONAL_CODE_REFERAL_ERROR"
export const PERSONAL_CODE_REFERAL_CLEAN = "PERSONAL_CODE_REFERAL_CLEAN"

export const RECOVER_EMAIL = "RECOVER_EMAIL"
export const RECOVER_CODE = "RECOVER_CODE"
export const RECOVER_PASSWORD = "RECOVER_PASSWORD"
export const IS_LOADING_RECOVER_CODE = "IS_LOADING_RECOVER_CODE"
export const RESET_PASSWORD = "RESET_PASSWORD"

export const IS_LOADING_SOCIAL_LOGIN = "IS_LOADING_SOCIAL_LOGIN"
export const REGISTER_SOCIAL_EMAIL = "REGISTER_SOCIAL_EMAIL"
export const REGISTER_SOCIAL_USER = "REGISTER_SOCIAL_USER"
export const LOGIN_SOCIAL_USER = "LOGIN_SOCIAL_USER"

export const IS_LOADING_CONFIGURATION_NOTIFICATIONS = "IS_LOADING_CONFIGURATION_NOTIFICATIONS"
export const CONFIGURATION_NOTIFICATION = "CONFIGURATION_NOTIFICATION"
export const IS_LOADING_CHANGE_CONFIGURATION_NOTIFICATION = "IS_LOADING_CHANGE_CONFIGURATION_NOTIFICATION"
export const CHANGE_CONFIGURATION_NOTIFICATION = "CHANGE_CONFIGURATION_NOTIFICATION"

export const FILE_UPLOADING = "FILE_UPLOADING"
export const FILE_LOADING_DONE = "FILE_LOADING_DONE"
export const FILE_LOADING_ERROR = "FILE_LOADING_ERROR"

export const IS_LOADING_POST_HOME = "IS_LOADING_POST_HOME"
export const GET_POST_HOME = "GET_POST_HOME"
export const IS_LOADING_POST_HOME_PROFESSIONAL = "IS_LOADING_POST_HOME_PROFESSIONAL"
export const GET_POST_HOME_PROFESSIONAL = "GET_POST_HOME_PROFESSIONAL"
export const IS_LOADING_ADD_POST_HOME = "IS_LOADING_ADD_POST_HOME"
export const ERROR_ADD_POST_HOME = "ERROR_ADD_POST_HOME"
export const ADD_POST_HOME = "ADD_POST_HOME"
export const ADD_POST_HOME_CAMPAIGN = "ADD_POST_HOME_CAMPAIGN"
export const ADD_LIKE_POST_HOME = "ADD_LIKE_POST_HOME"
export const IS_LOADING_LIKE_POST_HOME = "IS_LOADING_LIKE_POST_HOME"
export const REMOVE_LIKE_POST_HOME = "REMOVE_LIKE_POST_HOME"
export const DELETE_COUNT_COMMENT_POST_HOME = "DELETE_COUNT_COMMENT_POST_HOME"
export const ADD_COUNT_COMMENT_POST_HOME = "ADD_COUNT_COMMENT_POST_HOME"
export const IS_LOADING_ADD_COUNT_COMMENT_POST_HOME = "IS_LOADING_ADD_COUNT_COMMENT_POST_HOME"


export const PROFESSIONAL_GET_USER_POSTS = "PROFESSIONAL_GET_USER_POSTS"
export const PROFESSIONAL_IS_LOADING_DATA_PROFILE = "PROFESSIONAL_IS_LOADING_DATA_PROFILE"
export const PROFESSIONAL_DELETE_POST = "PROFESSIONAL_DELETE_POST"

export const GET_USER_INFO = "GET_USER_INFO"
export const IS_LOADING_PRIVATE_USER_INFO = "IS_LOADING_PRIVATE_USER_INFO"
export const UPDATE_PRIVATE_USER_INFO = "UPDATE_PRIVATE_USER_INFO"
export const IS_LOADING_GET_USER_INFO = "IS_LOADING_GET_USER_INFO"
export const IS_LOADING_GET_USERS = "IS_LOADING_GET_USERS"
export const IS_LOADING_FRIEND_LIST = "IS_LOADING_FRIEND_LIST"
export const CLEAR_FRIEND_LIST = "CLEAR_FRIEND_LIST"
export const IS_LOADING_BLOCKED_FRIEND_LIST = "IS_LOADING_BLOCKED_FRIEND_LIST"
export const GET_USER_POSTS = "GET_USER_POSTS"
export const GET_ZONE_POSTS = "GET_ZONE_POSTS"

export const LOAD_ZONE_POSTS = "LOAD_ZONE_POSTS"
export const ADD_ZONE_POSTS_ERROR = "ADD_ZONE_POSTS_ERROR"
export const ADD_ZONE_POSTS = "ADD_ZONE_POSTS"
export const IS_LOADING_DATA_PROFILE = "IS_LOADING_DATA_PROFILE"
export const DELETE_POST = "DELETE_POST"
export const IS_LOADING_POSTS = "IS_LOADING_POSTS"
export const GET_USER_ALBUMS = "GET_USER_ALBUMS"
export const IS_LOADING_GET_USER_ALBUMS = "IS_LOADING_GET_USER_ALBUMS"
export const IS_NOT_LOADING_GET_USER_ALBUMS = "IS_NOT_LOADING_GET_USER_ALBUMS"
export const GET_ALBUM_INFO = "GET_ALBUM_INFO"
export const IS_LOADING_GET_ALBUM_INFO = "IS_LOADING_GET_ALBUM_INFO"
export const DELETE_ALBUM = "DELETE_ALBUM"
export const POST_ALBUM_INFO = "POST_ALBUM_INFO"
export const CLEAR_POST_ALBUM_INFO = "CLEAR_POST_ALBUM_INFO"
export const CLEAR_POST_ALBUMS = "CLEAR_POST_ALBUMS"
export const IS_LOADING_POST_ALBUM = "IS_LOADING_POST_ALBUM"
export const BACK_TO_VIEW_ALBUMS = "BACK_TO_VIEW_ALBUMS"
export const GET_TYPE_OF_REPORT = "GET_TYPE_OF_REPORT"
export const IS_LOADING_GET_TYPE_OF_REPORT = "IS_LOADING_GET_TYPE_OF_REPORT"
export const IS_LOADING_LIST_MY_POST_REPORTED = "IS_LOADING_LIST_MY_POST_REPORTED"
export const LIST_MY_POST_REPORTED = "LIST_MY_POST_REPORTED"
export const CHANGE_MY_POST_REPORTED = "CHANGE_MY_POST_REPORTED"
export const IS_LOADING_POST_INFO = "IS_LOADING_POST_INFO"
export const POST_INFO = "POST_INFO"
export const CLEAR_POST_INFO = "CLEAR_POST_INFO"
export const IS_LOADING_LIST_POST_I_REPORTED = "IS_LOADING_LIST_POST_I_REPORTED"
export const LIST_POST_I_REPORTED = "LIST_POST_I_REPORTED"
export const IS_LOADING_LIST_POST_I_REPORTED_FROM_LIST = "IS_LOADING_LIST_POST_I_REPORTED_FROM_LIST"
export const CANCEL_POST_I_REPORTED_FROM_LIST = "CANCEL_POST_I_REPORTED_FROM_LIST"
export const IS_LOADING_LIKE_POST = "IS_LOADING_LIKE_POST"
export const ADD_LIKE_POST = "ADD_LIKE_POST"


export const IS_LOADING_FRIENDS = "IS_LOADING_FRIENDS"
export const ADD_FRIEND = "ADD_FRIEND"
export const GET_PROFILE_INFO = "GET_PROFILE_INFO"
export const ACCEPT_FRIEND_REQUEST = "ACCEPT_FRIEND_REQUEST"
export const CANCEL_FRIEND_REQUEST = "CANCEL_FRIEND_REQUEST"
export const DELETE_FRIEND = "DELETE_FRIEND"
export const BLOCK_FRIEND = "BLOCK_FRIEND"
export const UNBLOCK_FRIEND = "UNBLOCK_FRIEND"
export const SEE_FRIEND_REQUESTS = "SEE_FRIEND_REQUESTS"
export const SEE_FRIEND_LIST = "SEE_FRIEND_LIST"
export const SEE_BLOCKED_FRIEND_LIST = "SEE_BLOCKED_FRIEND_LIST"
export const SEE_FOLLOWING_LIST = "SEE_FOLLOWING_LIST"
export const SEE_FOLLOWERS_LIST = "SEE_FOLLOWERS_LIST"
export const IS_LOADING_FOLLOWING_LIST = "IS_LOADING_FOLLOWING_LIST"
export const IS_LOADING_FOLLOWERS_LIST = "IS_LOADING_FOLLOWERS_LIST"
export const UNFOLLOW_USER = "UNFOLLOW_USER"

export const SEE_COMMENTS = "SEE_COMMENTS"
export const SEE_COMMENTS_MULTI = "SEE_COMMENTS_MULTI"
export const ADD_COMMENT = "ADD_COMMENT"
export const IS_LOADING_COMMENTS = "IS_LOADING_COMMENTS"
export const DELETE_COMMENTS = "DELETE_COMMENTS"
export const IS_LOADING_LIKE_COMMENTARY = "IS_LOADING_LIKE_COMMENTARY"
export const ADD_LIKE_COMMENTARY = "ADD_LIKE_COMMENTARY"
export const ADD_LIKE_REPLY_COMMENTARY = "ADD_LIKE_REPLY_COMMENTARY"
export const ADD_COMMENT_MULTI = "ADD_COMMENT_MULTI"
export const IS_LOADING_COMMENTS_MULTI = "IS_LOADING_COMMENTS_MULTI"
export const DELETE_COMMENTS_MULTI = "DELETE_COMMENTS_MULTI"
export const SEE_REPLY_COMMENTS = "SEE_REPLY_COMMENTS"
export const ADD_REPLY_COMMENT = "ADD_REPLY_COMMENT"
export const IS_LOADING_REPLY_COMMENTS = "IS_LOADING_REPLY_COMMENTS"
export const DELETE_REPLY_COMMENTS = "DELETE_REPLY_COMMENTS"

export const ADD_COUNT_SHARED_POST_PROFILE = "ADD_COUNT_SHARED_POST_PROFILE"

export const ADD_COUNT_COMMENT_POST_PROFILE = "ADD_COUNT_COMMENT_POST_PROFILE"
export const DELETE_COUNT_COMMENT_POST_PROFILE = "DELETE_COUNT_COMMENT_POST_PROFILE"
export const IS_LOADING_ADD_COUNT_COMMENT_POST_PROFILE = "IS_LOADING_ADD_COUNT_COMMENT_POST_PROFILE"
export const IS_LOADING_COUNT_REPLY_COMMENTS = "IS_LOADING_COUNT_REPLY_COMMENTS"
export const GET_USERS = "GET_USERS"
export const GLOBAL_SEARCH = "GLOBAL_SEARCH"
export const GET_RELATION_BETWEEN = "GET_RELATION_BETWEEN"
export const LOAD_RELATION_BETWEEN = "LOAD_RELATION_BETWEEN"
export const CHANGE_RELATION_BETWEEN = "CHANGE_RELATION_BETWEEN"

export const SEARCH_FRIENDS = "SEARCH_FRIENDS"
export const IS_LOADING_SEARCH_FRIENDS = "IS_LOADING_SEARCH_FRIENDS"
export const IS_LOADING_SEARCH = "IS_LOADING_SEARCH"

export const IS_LOADING_LIKE_POST_PROFILE = "IS_LOADING_LIKE_POST_PROFILE"
export const ADD_LIKE_POST_PROFILE = "ADD_LIKE_POST_PROFILE"
export const REMOVE_LIKE_POST_PROFILE = "REMOVE_LIKE_POST_PROFILE"

export const GET_PROFESSIONAL_INFO = "GET_PROFESSIONAL_INFO"
export const IS_LOADING_DATA_PROFESSIONAL = "IS_LOADING_DATA_PROFESSIONAL"
export const STUDY_INFO_CREATED = "STUDY_INFO_CREATED"
export const EXPERIENCE_INFO_CREATED = "EXPERIENCE_INFO_CREATED"
export const CREATE_CERTIFICATE = "CREATE_CERTIFICATE"
export const DELETE_CERTIFICATE = "DELETE_CERTIFICATE"
export const GET_STUDY_LIST = "GET_STUDY_LIST"
export const GET_EXPERIENCE_LIST = "GET_EXPERIENCE_LIST"
export const IS_LOADING_GET_EXPERIENCE_LIST = "IS_LOADING_GET_EXPERIENCE_LIST"
export const IS_LOADING_GET_STUDY_LIST = "IS_LOADING_GET_STUDY_LIST"
export const DELETE_STUDY = "DELETE_STUDY"
export const DELETE_EXPERIENCE = "DELETE_EXPERIENCE"
export const EDIT_EXPERIENCE = "EDIT_EXPERIENCE"
export const EDIT_STUDY = "EDIT_STUDY"
export const GET_STUDY_INFO = "GET_STUDY_INFO"
export const GET_EXPERIENCE_INFO = "GET_EXPERIENCE_INFO"
export const IS_LOADING_GET_STUDY_INFO = "IS_LOADING_GET_STUDY_INFO"
export const IS_LOADING_GET_EXPERIENCE_INFO = "IS_LOADING_GET_EXPERIENCE_INFO"
export const GET_CURRENT_STUDIES = "GET_CURRENT_STUDIES"
export const GET_CURRENT_EXPERIENCES = "GET_CURRENT_EXPERIENCES"
export const IS_LOADING_GET_CURRENT_STUDIES = "IS_LOADING_GET_CURRENT_STUDIES"
export const IS_LOADING_GET_CURRENT_EXPERIENCES = "IS_LOADING_GET_CURRENT_EXPERIENCES"
export const PROFESSIONAL_SEARCH_LIST = "PROFESSIONAL_SEARCH_LIST"
export const IS_LOADING_GET_PROFESSIONAL_SEARCH_LIST = "IS_LOADING_GET_PROFESSIONAL_SEARCH_LIST"



export const GET_PROFESSIONAL_LIST = "GET_PROFESSIONAL_LIST"
export const SEE_CONTACT_REQUESTS = "SEE_CONTACT_REQUESTS"
export const SEE_CONTACT_LIST = "SEE_CONTACT_LIST"
export const SEE_BLOCKED_CONTACT_LIST = "SEE_BLOCKED_CONTACT_LIST"
export const IS_LOADING_CONTACTS = "IS_LOADING_CONTACTS"
export const ACCEPT_CONTACT_REQUEST = "ACCEPT_CONTACT_REQUEST"
export const CANCEL_CONTACT_REQUEST = "CANCEL_CONTACT_REQUEST"
export const IS_LOADING_CONTACT_LIST = "IS_LOADING_CONTACT_LIST"
export const DELETE_CONTACT = "DELETE_CONTACT"
export const BLOCK_CONTACT = "BLOCK_CONTACT"
export const UNBLOCK_CONTACT = "UNBLOCK_CONTACT"
export const IS_LOADING_BLOCKED_CONTACT_LIST = "IS_LOADING_BLOCKED_CONTACT_LIST"
export const LOAD_CONTACT_RELATION_BETWEEN = "LOAD_CONTACT_RELATION_BETWEEN"
export const CHANGE_CONTACT_RELATION_BETWEEN = "CHANGE_CONTACT_RELATION_BETWEEN"
export const IS_LOADING_GET_PROFESSIONAL_LIST = "IS_LOADING_GET_PROFESSIONAL_LIST"
export const IS_LOADING_CONTACTS_REQUEST = "IS_LOADING_CONTACTS_REQUEST"

export const FILE_LOADING_ERROR_PROFESSIONAL = "FILE_LOADING_ERROR_PROFESSIONAL"
export const FILE_LOADING_DONE_PROFESSIONAL = "FILE_LOADING_DONE_PROFESSIONAL"
export const FILE_UPLOADING_PROFESSIONAL = "FILE_UPLOADING_PROFESSIONAL"

export const IS_LOADING_POINT_PACKAGES = "IS_LOADING_POINT_PACKAGES"
export const LIST_OF_POINT_PACKAGES = "LIST_OF_POINT_PACKAGES"
export const LIST_OF_POINT_PACKAGES_OF_MARK = "LIST_OF_POINT_PACKAGES_OF_MARK"
export const IS_LOADING_POINT_PACKAGES_OF_MARK = "IS_LOADING_POINT_PACKAGES_OF_MARK"

export const IS_LOADING_GET_MY_ROOMS = "IS_LOADING_GET_MY_ROOMS"
export const GET_MY_ROOMS = "GET_MY_ROOMS"
export const DELETE_ADMIN_ROOM = "DELETE_ADMIN_ROOM"
export const DELETE_ROOM = "DELETE_ROOM"
export const IS_LOADING_GET_ROOM_INFO = "IS_LOADING_GET_ROOM_INFO"
export const GET_ROOM_INFO = "GET_ROOM_INFO"
export const ERROR_GET_ROOM_INFO = "ERROR_GET_ROOM_INFO"
export const CLEAR_ROOM_INFO = "CLEAR_ROOM_INFO"
export const IS_LOADING_GET_MEMBERS_ROOM = "IS_LOADING_GET_MEMBERS_ROOM"
export const GET_MEMBERS_ROOM = "GET_MEMBERS_ROOM"
export const DELETE_MEMBER_ROOM = "DELETE_MEMBER_ROOM"
export const IS_LOADING_GET_ALL_ROOMS = "IS_LOADING_GET_ALL_ROOMS"
export const GET_ALL_ROOMS = "GET_ALL_ROOMS"
export const GET_ALL_ROOMS_FILTER = "GET_ALL_ROOMS_FILTER"
export const IS_LOADING_GET_ROOMS_I_BELONG = "IS_LOADING_GET_ROOMS_I_BELONG"
export const ADD_TO_ROOMS_I_BELONG = "ADD_TO_ROOMS_I_BELONG"
export const GET_ROOMS_I_BELONG = "GET_ROOMS_I_BELONG"
export const REMOVE_REQUEST_FROM_ROOM = "REMOVE_REQUEST_FROM_ROOM"


export const LOADING_CHECK_USER_IN_ROOM = "LOADING_CHECK_USER_IN_ROOM"
export const CHECK_USER_IN_ROOM = "CHECK_USER_IN_ROOM"
export const LOADING_CHECK_USER_IN_COMMUNITY = "LOADING_CHECK_USER_IN_COMMUNITY"
export const CHECK_USER_IN_COMMUNITY = "CHECK_USER_IN_COMMUNITY"
export const CLEAR_USER_IN_COMMUNITY = "CLEAR_USER_IN_COMMUNITY"

export const IS_LOADING_GET_MY_COMMUNITIES = "IS_LOADING_GET_MY_COMMUNITIES"
export const IS_LOADING_GET_MY_COMMUNITIES_AND_CATEGORY = " IS_LOADING_GET_MY_COMMUNITIES_AND_CATEGORY"
export const GET_MY_COMMUNITIES_AND_CATEGORY = "GET_MY_COMMUNITIES_AND_CATEGORY"
export const GET_MY_COMMUNITIES = "GET_MY_COMMUNITIES"
export const DELETE_MY_COMMUNITY = "DELETE_MY_COMMUNITY"
export const IS_LOADING_GET_COMMUNITY_INFO = "IS_LOADING_GET_COMMUNITY_INFO"
export const ERROR_GET_COMMUNITY_INFO = "ERROR_GET_COMMUNITY_INFO"

export const GET_COMMUNITY_INFO = "GET_COMMUNITY_INFO"
export const IS_LOADING_GET_COMMUNITY_REQUESTS = "IS_LOADING_GET_COMMUNITY_REQUESTS"
export const GET_COMMUNITY_REQUESTS = "GET_COMMUNITY_REQUESTS"
export const ACCEPT_COMMUNITY_REQUEST = "ACCEPT_COMMUNITY_REQUEST"
export const CANCEL_COMMUNITY_REQUEST = "CANCEL_COMMUNITY_REQUEST"
export const IS_LOADING_GET_COMMUNITY_MEMBERS = "IS_LOADING_GET_COMMUNITY_MEMBERS"
export const GET_COMMUNITY_MEMBERS = "GET_COMMUNITY_MEMBERS"

export const IS_LOADING_GET_COMMUNITY_MEMBERS_REJECTED = "IS_LOADING_GET_COMMUNITY_MEMBERS_REJECTED"
export const GET_COMMUNITY_MEMBERS_REJECTED = "GET_COMMUNITY_MEMBERS_REJECTED"
export const BLOCK_COMMUNITY_USER = "BLOCK_COMMUNITY_USER"
export const REMOVE_COMMUNITY_MEMBER = "REMOVE_COMMUNITY_MEMBER"
export const IS_LOADING_GET_COMMUNITY_MEMBERS_BLOCKED = "IS_LOADING_GET_COMMUNITY_MEMBERS_BLOCKED"
export const GET_COMMUNITY_MEMBERS_BLOCKED = "GET_COMMUNITY_MEMBERS_BLOCKED"
export const GET_MANAGER_COMMUNITY_INFO = "GET_MANAGER_COMMUNITY_INFO"
export const IS_LOADING_GET_MANAGER_COMMUNITY_LIST = "IS_LOADING_GET_MANAGER_COMMUNITY_LIST"
export const GET_MANAGER_COMMUNITY_LIST = "GET_MANAGER_COMMUNITY_LIST"
export const DELETE_MANAGER_COMMUNITY = "DELETE_MANAGER_COMMUNITY"
export const ASIGN_MANAGER_TYPE = "ASIGN_MANAGER_TYPE"
export const UNBLOCK_COMMUNITY_MEMBER = "UNBLOCK_COMMUNITY_MEMBER"

export const IS_LOADING_GET_ROOM_REQUESTS = "IS_LOADING_GET_ROOM_REQUESTS"
export const GET_ROOM_REQUESTS = "GET_ROOM_REQUESTS"
export const REMOVE_ROOM_REQUEST = "REMOVE_ROOM_REQUEST"
export const IS_LOADING_GET_USER_REQUESTS_FROM_ROOM = "IS_LOADING_GET_USER_REQUESTS_FROM_ROOM"
export const GET_USER_REQUESTS_FROM_ROOM = "GET_USER_REQUESTS_FROM_ROOM"
export const IS_LOADING_COMMUNITY_BY_CATEGORIES = "IS_LOADING_COMMUNITY_BY_CATEGORIES"
export const COMMUNITIES_BY_CATEGORY = "COMMUNITIES_BY_CATEGORY"


export const IS_LOADING_LIST_CLASSIFIED = "IS_LOADING_LIST_CLASSIFIED"
export const DELETE_CLASSIFIED = "DELETE_CLASSIFIED"
export const IS_LOADING_LIST_CLASSIFIEDS_OTHERS = "IS_LOADING_LIST_CLASSIFIEDS_OTHERS"
export const LIST_CLASSIFIEDS_OTHERS = "LIST_CLASSIFIEDS_OTHERS"
export const IS_LOADING_CLASSIFIEDS_IMAGES = "IS_LOADING_CLASSIFIEDS_IMAGES"
export const CLASSIFIED_IMAGES = "CLASSIFIED_IMAGES"
export const DELETE_CLASSIFIED_IMAGE = "DELETE_CLASSIFIED_IMAGE"
export const IS_LOADING_CLASSIFIED_INFO = "IS_LOADING_CLASSIFIED_INFO"
export const CLASSIFIED_INFO = "CLASSIFIED_INFO"
export const IS_LOADING_LIST_CLASSIFIEDS = "IS_LOADING_LIST_CLASSIFIEDS"
export const LIST_CLASSIFIEDS = "LIST_CLASSIFIEDS"
export const IS_LOADING_SELLER_RATE = "IS_LOADING_SELLER_RATE"
export const SELLER_RATE = "SELLER_RATE"
export const CHANGE_SELLER_RATE = "CHANGE_SELLER_RATE"
export const IS_LOADING_LOCATION_COUNTRY = "IS_LOADING_LOCATION_COUNTRY"
export const LOCATION_COUNTRY = "LOCATION_COUNTRY"
export const IS_LOADING_LOCATION_STATE = "IS_LOADING_LOCATION_STATE"
export const LOCATION_STATE = "LOCATION_STATE"
export const IS_LOADING_LOCATION_CITIES = "IS_LOADING_LOCATION_CITIES"
export const LOCATION_CITIES = "LOCATION_CITIES"
export const IS_LOADING_GET_MY_ROOMS_AND_CATEGORY = "IS_LOADING_GET_MY_ROOMS_AND_CATEGORY"
export const GET_MY_ROOMS_AND_CATEGORY = "GET_MY_ROOMS_AND_CATEGORY"

export const IS_LOADING_LIST_CLASSIFIED_SAVED = "IS_LOADING_LIST_CLASSIFIED_SAVED"
export const LIST_CLASSIFIED_SAVED = "LIST_CLASSIFIED_SAVED"
export const IS_LOADING_LIST_POST_SAVED = "IS_LOADING_LIST_POST_SAVED"
export const LIST_POST_SAVED = "LIST_POST_SAVED"
export const REMOVE_CLASSIFIED_SAVED = "REMOVE_CLASSIFIED_SAVED"
export const REMOVE_POST_SAVED = "REMOVE_POST_SAVED"

export const IS_LOADING_USER_CHALLENGES = "IS_LOADING_USER_CHALLENGES"
export const USER_CHALLENGES = "USER_CHALLENGES"
export const IS_LOADING_USER_BADGES = "IS_LOADING_USER_BADGES"
export const USER_BADGES = "USER_BADGES"

export const IS_LOADING_QRS_MARK = "IS_LOADING_QRS_MARK"
export const CREATE_MARK_QR = "CREATE_MARK_QR"
export const QRS_MARK = "QRS_MARK"
export const DELETE_QR_MARK = "DELETE_QR_MARK"

export const IS_LOADING_NOTIFICATIONS_ADDRESSEE = "IS_LOADING_NOTIFICATIONS_ADDRESSEE"
export const NOTIFICATIONS_ADDRESSEE = "NOTIFICATIONS_ADDRESSEE"
export const ADD_NOTIFICATIONS_ADDRESSEE = "ADD_NOTIFICATIONS_ADDRESSEE"
export const DELETE_NOTIFICATION_ADDRESSEE = "DELETE_NOTIFICATION_ADDRESSEE"
export const IS_LOADING_VIEW_NOTIFICATION = "IS_LOADING_VIEW_NOTIFICATION"
export const VIEW_NOTIFICATION = "VIEW_NOTIFICATION"

export const IS_LOADING_SEND_MESSAGE = "IS_LOADING_SEND_MESSAGE"
export const SEND_MESSAGE = "SEND_MESSAGE"
export const IS_LOADING_CONVERSATION = "IS_LOADING_CONVERSATION"
export const CONVERSATION = "CONVERSATION"
export const IS_LOADING_SEND_MESSAGE_ROOM = "IS_LOADING_SEND_MESSAGE_ROOM"
export const SEND_MESSAGE_ROOM = "SEND_MESSAGE_ROOM"
export const IS_LOADING_CONVERSATION_ROOM = "IS_LOADING_CONVERSATION_ROOM"
export const CONVERSATION_ROOM = "CONVERSATION_ROOM"
export const IS_LOADING_CONVERSATIONS_LIST = "IS_LOADING_CONVERSATIONS_LIST"
export const CONVERSATIONS_LIST = "CONVERSATIONS_LIST"
export const NEW_MESSAGE = "NEW_MESSAGE"
export const NEW_MESSAGE_ROOM = "NEW_MESSAGE_ROOM"
export const DELETE_CONVERSATION = "DELETE_CONVERSATION"

export const IS_LOADING_LIST_PQRS_USER = "IS_LOADING_LIST_PQRS_USER"
export const LIST_PQRS_USER = "LIST_PQRS_USER"
export const CREATE_PQRS_USER = "CREATE_PQRS_USER"
export const DISABLE_PQRS_USER = "DISABLE_PQRS_USER"

export const IS_LOADING_PAYMENT_USER = "IS_LOADING_PAYMENT_USER"
export const PAYMENT_USER = "PAYMENT_USER"


export const IS_LOADING_LIST_POST_PENDING_COMMUNITY = "IS_LOADING_LIST_POST_PENDING_COMMUNITY"
export const LIST_POST_PENDING_COMMUNITY = "LIST_POST_PENDING_COMMUNITY"
export const CHANGE_STATUS_PENDING_COMMUNITY = "CHANGE_STATUS_PENDING_COMMUNITY"

export const IS_LOADING_BLOCK_VENDOR = "IS_LOADING_BLOCK_VENDOR"
export const BLOCK_VENDOR = "BLOCK_VENDOR"
export const IS_LOADING_BLOCK_VENDOR_LIST = "IS_LOADING_BLOCK_VENDOR_LIST"
export const UNBLOCK_VENDOR = "UNBLOCK_VENDOR"
export const BLOCK_VENDOR_LIST = "BLOCK_VENDOR_LIST"


export const IS_LOADING_STORIES_LIST = "IS_LOADING_STORIES_LIST"
export const STORIES_LIST = "STORIES_LIST"
export const IS_LOADING_STORY_INFO = "IS_LOADING_STORY_INFO"
export const STORY_INFO = "STORY_INFO"
export const IS_LOADING_CREATE_STORY = "IS_LOADING_CREATE_STORY"
export const CREATE_STORY = "CREATE_STORY"
export const IS_LOADING_DELETE_STORY = "IS_LOADING_DELETE_STORY"
export const DELETE_STORY = "DELETE_STORY"
export const IS_LOADING_ARCHIVED_STORIES_LIST = "IS_LOADING_ARCHIVED_STORIES_LIST"
export const ARCHIVED_STORIES_LIST = "ARCHIVED_STORIES_LIST"
export const UN_ARCHIVED_STORY = "UN_ARCHIVED_STORY"

export const IS_LOADING_LIST_COMMUNITY_I_REPORTED_FROM_LIST = "IS_LOADING_LIST_COMMUNITY_I_REPORTED_FROM_LIST"
export const CANCEL_COMMUNITY_I_REPORTED_FROM_LIST = "CANCEL_COMMUNITY_I_REPORTED_FROM_LIST"
export const IS_LOADING_LIST_COMMUNITY_I_REPORTED = "IS_LOADING_LIST_COMMUNITY_I_REPORTED"
export const CANCEL_COMMUNITY_I_REPORTED = "CANCEL_COMMUNITY_I_REPORTED"
export const COMMUNITY_I_REPORTED_LIST = "COMMUNITY_I_REPORTED_LIST"
export const CHANGE_STATUS_COMMUNITY_REPORTED = "CHANGE_STATUS_COMMUNITY_REPORTED"
export const IS_LOADING_MY_LIST_COMMUNITY_REPORTED = "IS_LOADING_MY_LIST_COMMUNITY_REPORTED"
export const MY_LIST_COMMUNITY_REPORTED = "MY_LIST_COMMUNITY_REPORTED"

export const IS_LOADING_LIST_OF_USER_SETTINGS = "IS_LOADING_LIST_OF_USER_SETTINGS"
export const CREATE_USER_SETTINGS = "CREATE_USER_SETTINGS"
export const EDIT_USER_SETTINGS = "EDIT_USER_SETTINGS"
export const DELETE_USER_SETTINGS = "DELETE_USER_SETTINGS"
export const LIST_OF_USER_SETTINGS = "LIST_OF_USER_SETTINGS"

export const IS_LOADING_USER_RANKING = "IS_LOADING_USER_RANKING"
export const USER_RANKING = "USER_RANKING"

export const CREATE_STREAM = "CREATE_STREAM"
export const CREATE_POST_STREAM = "CREATE_POST_STREAM"

export const ADD_TO_BAG = "ADD_TO_BAG"
export const REMOVE_ITEM = "REMOVE_ITEM"
export const CHANGE_QUANTITY = "CHANGE_QUANTITY"
export const ADD_TO_POINTS_BAG = "ADD_TO_POINTS_BAG"
export const REMOVE_ITEM_POINTS_BAG = "REMOVE_ITEM_POINTS_BAG"
export const CHANGE_QUANTITY_POINTS_BAG = "CHANGE_QUANTITY_POINTS_BAG"
export const PAY_SUCCESS = "PAY_SUCCESS"
export const GET_PURCHASES = "GET_PURCHASES"
export const GET_BATCHES_USER = "GET_BATCHES_USER"
export const GET_REASONS = "GET_REASONS"

export const LOADING_INFO_ORDER = "LOADING_INFO_ORDER"
export const GET_INFO_ORDER = "GET_INFO_ORDER"
export const ERROR_INFO_ORDER = "ERROR_INFO_ORDER"
export const CLEAR_INFO_ORDER = "CLEAR_INFO_ORDER"

export const GET_COUNTRIES = "GET_COUNTRIES"
export const GET_STATES = "GET_STATES"
export const GET_CITIES = "GET_CITIES"
export const CLEAR_COUNTRIES = "CLEAR_COUNTRIES"
export const CLEAR_STATES = "CLEAR_STATES"
export const CLEAR_CITIES = "CLEAR_CITIES"

export const GET_INVENTORY_ECOTIENDA = "GET_INVENTORY_ECOTIENDA"
export const GET_INVENTORY_WAREHOUSE = "GET_INVENTORY_WAREHOUSE"
export const GET_INVENTORY_REPRESENTATIVE = "GET_INVENTORY_REPRESENTATIVE"
export const IS_LOADING_GET_ALL_WINERIES = "IS_LOADING_GET_ALL_WINERIES"
export const GET_ALL_WINERIES = "GET_ALL_WINERIES"
export const IS_LOADING_GET_ALL_SUB_WINERIES = "IS_LOADING_GET_ALL_SUB_WINERIES"
export const GET_ALL_SUB_WINERIES = "GET_ALL_SUB_WINERIES"
export const IS_LOADING_GET_ALL_WAREHOUSES = "IS_LOADING_GET_ALL_WAREHOUSES"
export const GET_ALL_WAREHOUSES = "GET_ALL_WAREHOUSES"
export const IS_LOADING_GET_POST_ALL_REPRESENTATIVES = "IS_LOADING_GET_POST_ALL_REPRESENTATIVES"
export const GET_POST_ALL_REPRESENTATIVES = "GET_POST_ALL_REPRESENTATIVES"
export const IS_LOADING_GET_ALL_FRANCHISES = "IS_LOADING_GET_ALL_FRANCHISES"
export const GET_ALL_FRANCHISES = "GET_ALL_FRANCHISES"
export const IS_LOADING_GET_POST_PRODUCTS_BY_LOCATION = "IS_LOADING_GET_POST_PRODUCTS_BY_LOCATION"
export const GET_POST_PRODUCTS_BY_LOCATION = "GET_POST_PRODUCTS_BY_LOCATION"
export const IS_LOADING_GET_POST_BATCHES_BY_LOCATION = "IS_LOADING_GET_POST_BATCHES_BY_LOCATION"
export const GET_POST_BATCHES_BY_LOCATION = "GET_POST_BATCHES_BY_LOCATION"
export const IS_LOADING_GET_POST_INVENTORY_CONSOLIDATE_PRODUCTS = "IS_LOADING_GET_POST_INVENTORY_CONSOLIDATE_PRODUCTS"
export const GET_POST_INVENTORY_CONSOLIDATE_PRODUCTS = "GET_POST_INVENTORY_CONSOLIDATE_PRODUCTS"


export const GET_POINTS_BY_OIL_DELIVERY = "GET_POINTS_BY_OIL_DELIVERY"
export const IS_LOADING_POINTS_BY_OIL_DELIVERY = "IS_LOADING_POINTS_BY_OIL_DELIVERY"
export const POST_RECORD_DELIVERY = "POST_RECORD_DELIVERY"
export const IS_LOADING_POST_REGISTER = "IS_LOADING_POST_REGISTER"
export const ERROR_POST_RECORD_DELIVERY = "ERROR_POST_RECORD_DELIVERY"
export const GET_POST_TOTAL_RECEIVED = "GET_POST_TOTAL_RECEIVED"
export const IS_LOADING_GET_ALL_RECEIVED_OIL = "IS_LOADING_GET_ALL_RECEIVED_OIL"
export const GET_ALL_RECEIVED_OIL = "GET_ALL_RECEIVED_OIL"
export const IS_LOADING_GET_POST_CONSOLIDATE_OIL_DELIVERING = "IS_LOADING_GET_POST_CONSOLIDATE_OIL_DELIVERING"
export const GET_POST_CONSOLIDATE_OIL_DELIVERING = "GET_POST_CONSOLIDATE_OIL_DELIVERING"
export const IS_LOADING_GET_OIL_RECEIVED_BY_ECOIDEAS = "IS_LOADING_GET_OIL_RECEIVED_BY_ECOIDEAS"
export const GET_OIL_RECEIVED_BY_ECOIDEAS = "GET_OIL_RECEIVED_BY_ECOIDEAS"
export const IS_LOADING_GET_POST_HISTORICAL_OIL_DELIVERING = "IS_LOADING_GET_POST_HISTORICAL_OIL_DELIVERING"
export const GET_POST_HISTORICAL_OIL_DELIVERING = "GET_POST_HISTORICAL_OIL_DELIVERING"

export const LOAD_STIKERS = "LOAD_STIKERS"
export const GET_STIKERS = "GET_STIKERS"

export const IS_LOADING_POINTS_TO_REDEEM = "IS_LOADING_POINTS_TO_REDEEM"